module.exports = __webpack_public_path__ + "img/d9e4a9f.jpg";